import React, { useEffect } from "react";
import "./Project.css";
import link from "../../assets/project/link.png";
import jjcabs from "../../assets/project/jjcabs.png";
import mjdta from "../../assets/project/mjdta.png";
import payroll from "../../assets/project/payrolllogin.png";
import kiruarts from "../../assets/project/kiruarts.png";
import payments from "../../assets/project/payments.png";
import expense from "../../assets/project/expense.png";
import peacock from "../../assets/project/peaocokcafe.png"
import billing from "../../assets/project/billing.png"

const Projects = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    scrollToTop();
  }, []);
  return (
    <>
      <h2 className="text-4xl md:text-4xl text-center uppercase font-bold font-Kalam text-black pb-4 mt-10 ">
        <span class="underline underline-offset-3 decoration-3 decoration-black dark:decoration-black">
          Projects
        </span>
      </h2>
      <div className="flex-wrap items-center justify-center gap-8 text-center sm:flex m-10">
        <div className="w-full px-4 py-2 mt-6 bg-gray-900 rounded-lg shadow-lg sm:w-1/2 md:w-1/2 lg:w-1/4 dark:bg-gray-800">
          <div className="flex-shrink-0">
            <div className="flex items-center justify-center w-full h-48 mx-auto cursor-pointer">
              <a
                href="https://payroll.logimaxindia.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={payroll}
                  className="duration-100 hover:scale-105"
                  alt="payroll "
                />
              </a>
            </div>
          </div>
          <h3 className=" text-2xl mb-2 font-semibold text-white sm:text-xl dark:text-white">
            Simplified payroll software for every business in India
          </h3>
          <p className=" text-green-500 text-xl ">Completed</p>

          <div className="flex items-center justify-center">
            <a href="https://payroll.logimaxindia.com/" rel="noreferrer" className=" px-6 py-3 m-4 duration-200 hover:scale-105 text-white cursor-pointer">
              <img src={link} className="h-7  " alt="link" />
            </a>
          </div>
        </div>

        <div className="w-full px-4 py-2 mt-6 bg-gray-900 rounded-lg shadow-lg sm:w-1/2 md:w-1/2 lg:w-1/4 dark:bg-gray-800">
          <div className="flex-shrink-0">
            <div className="flex items-center justify-center w-full h-48 mx-auto ">
              <a
                href="#"
                rel="noreferrer"
                target="_blank"
              >
                <img
                  src={billing}
                  alt="billing"
                  className="duration-100 hover:scale-105"
                />
              </a>
            </div>
          </div>
          <h3 className=" text-2xl mb-2 font-semibold text-white sm:text-xl dark:text-white">
            Online billing software that offers a hassle-free billing solution for business.
          </h3>
          <p className=" text-green-500 text-xl ">Completed</p>
          <div className="flex   items-center justify-center">
            <a
              href="#"
              target="_blank"
              rel="noreferrer"
              className=" px-6 py-3 m-4 duration-200 hover:scale-105 text-white cursor-pointer"
            >
              <img src={link} className="h-7  " alt="link" />
            </a>
          </div>
        </div>

        <div className="w-full px-4 py-2 mt-6 bg-gray-900 rounded-lg shadow-lg sm:w-1/2 md:w-1/2 lg:w-1/4 dark:bg-gray-800">
          <div className="flex-shrink-0">
            <div className="flex items-center justify-center w-full h-48 mx-auto cursor-pointer">
              <a
                href="https://jewellery.logimaxindia.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={mjdta}
                  className="duration-100 hover:scale-105"
                  alt="mjdta"
                />
              </a>
            </div>
          </div>
          <h3 className=" text-2xl mb-2 font-semibold text-white sm:text-xl dark:text-white">
            The Jewellers and Diamond Traders' Association - Madras
          </h3>
          <p className=" text-green-500 text-xl ">Completed</p>

          <div className="flex items-center justify-center">
            <a
              href="https://jewellery.logimaxindia.com/"
              target="_blank"
              rel="noreferrer"
              className=" px-6 py-3 m-4 duration-200 hover:scale-105 text-white cursor-pointer"
            >
              <img src={link} className="h-7" alt="link" />
            </a>
          </div>
        </div>
      </div>

      <div className="flex-wrap items-center justify-center gap-8 text-center sm:flex m-10">
        <div className="w-full px-4 py-2 mt-6 bg-gray-900 rounded-lg shadow-lg sm:w-1/2 md:w-1/2 lg:w-1/4 dark:bg-gray-800">
          <div className="flex-shrink-0">
            <div className="flex items-center justify-center w-full h-48 mx-auto ">
              <a
                href="https://www.expensetracker.fun/"
                rel="noreferrer"
                target="_blank"
              >
                <img
                  src={expense}
                  alt="expense"
                  className="duration-100 hover:scale-105"
                />
              </a>
            </div>
          </div>
          <h3 className=" text-2xl mb-2 font-semibold text-white sm:text-xl dark:text-white">
            Expense Tracker - simplified online expense management, and
            effective cost control.
          </h3>
          <p className=" text-green-500 text-xl ">Completed</p>
          <div className="flex   items-center justify-center">
            <a
              href="https://www.expensetracker.fun/"
              rel="noreferrer"
              target="_blank"
              className=" px-6 py-3 m-4 duration-200 hover:scale-105 text-white cursor-pointer"
            >
              <img src={link} className="h-7  " alt="link" />
            </a>
          </div>
        </div>



        <div className="w-full px-4 py-2 mt-6 bg-gray-900 rounded-lg shadow-lg sm:w-1/2 md:w-1/2 lg:w-1/4 dark:bg-gray-800">
          <div className="flex-shrink-0">
            <div className="flex items-center justify-center w-full h-48 mx-auto ">
              <a
                href="https://paymentgatewaystesting.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={payments}
                  alt="payments"
                  className="duration-100 hover:scale-105"
                />
              </a>
            </div>
          </div>
          <h3 className=" text-2xl mb-2 font-semibold text-white sm:text-xl dark:text-white">
            Payments -Here you can find the Payment Gateway and Web
            Integrations.
          </h3>
          <p className=" text-blue-600 text-xl ">On Going</p>
          <div className="flex items-center justify-center">
            <a
              href="https://paymentgatewaystesting.vercel.app/"
              target="_blank"
              rel="noreferrer"
              className=" px-6 py-3 m-4 duration-200 hover:scale-105 text-white cursor-pointer"
            >
              <img src={link} className="h-7  " alt="link" />
            </a>
          </div>
        </div>

        <div className="w-full px-4 py-2 mt-6 bg-gray-900 rounded-lg shadow-lg sm:w-1/2 md:w-1/2 lg:w-1/4 dark:bg-gray-800">
          <div className="flex-shrink-0">
            <div className="flex items-center justify-center w-full h-48 mx-auto ">
              <a
                href="https://jjcabspollachi.vercel.app/"
                rel="noreferrer"
                target="_blank"
              >
                <img
                  src={jjcabs}
                  alt="jjcabs"
                  className="duration-100 hover:scale-105"
                />
              </a>
            </div>
          </div>
          <h3 className=" text-2xl mb-2 font-semibold text-white sm:text-xl dark:text-white">
            JJ CABS POLLACHI - A Mission to deliver Premium class Taxi service
            experience.
          </h3>
          <p className=" text-green-500 text-xl ">Completed</p>
          <div className="flex   items-center justify-center">
            <a
              href="https://jjcabspollachi.vercel.app/"
              target="_blank"
              rel="noreferrer"
              className=" px-6 py-3 m-4 duration-200 hover:scale-105 text-white cursor-pointer"
            >
              <img src={link} className="h-7  " alt="link" />
            </a>
          </div>
        </div>
      </div>


      <div className="flex-wrap items-center justify-center gap-8 text-center sm:flex m-10">
        <div className="w-full px-4 py-2 mt-6 bg-gray-900 rounded-lg shadow-lg sm:w-1/2 md:w-1/2 lg:w-1/4 dark:bg-gray-800">
          <div className="flex-shrink-0">
            <div className="flex items-center justify-center w-full h-48 mx-auto ">
              <a
                href="https://peacockcafe.vercel.app/"
                rel="noreferrer"
                target="_blank"
              >
                <img
                  src={peacock}
                  alt="peacock"
                  className="duration-100 hover:scale-105"
                />
              </a>
            </div>
          </div>
          <h3 className=" text-2xl mb-2 font-semibold text-white sm:text-xl dark:text-white">
            peacockcafe -  Explore the best Taste with Peacock Cafe.
          </h3>
          <p className=" text-green-500 text-xl ">Completed</p>
          <div className="flex   items-center justify-center">
            <a
              href="https://peacockcafe.vercel.app/"
              rel="noreferrer"
              target="_blank"
              className=" px-6 py-3 m-4 duration-200 hover:scale-105 text-white cursor-pointer"
            >
              <img src={link} className="h-7  " alt="link" />
            </a>
          </div>
        </div>
        <div className="w-full px-4 py-2 mt-6 bg-gray-900 rounded-lg shadow-lg sm:w-1/2 md:w-1/2 lg:w-1/4 dark:bg-gray-800">
          <div className="flex-shrink-0">
            <div className="flex items-center justify-center w-full h-48 mx-auto ">
              <a
                href="https://kiruarts.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={kiruarts}
                  alt="kiruarts"
                  className="duration-100 hover:scale-105"
                />
              </a>
            </div>
          </div>
          <h3 className=" text-2xl mb-2 font-semibold text-white sm:text-xl dark:text-white">
            Kiru Arts - Explore the Beauty and Elegance of Black Art.
          </h3>
          <p className=" text-green-500 text-xl ">Completed</p>

          <div className="flex items-center justify-center">
            <a
              href="https://kiruarts.vercel.app/"
              target="_blank"
              rel="noreferrer"
              className=" px-6 py-3 m-4 duration-200 hover:scale-105 text-white cursor-pointer"
            >
              <img src={link} className="h-7  " alt="link" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Projects;
